"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplenishmentErrorCodes = void 0;
var ReplenishmentErrorCodes;
(function (ReplenishmentErrorCodes) {
    // Generic error codes
    ReplenishmentErrorCodes["BAD_REQUEST"] = "BAD_REQUEST";
    ReplenishmentErrorCodes["ERR_BAD_REQUEST"] = "ERR_BAD_REQUEST";
    ReplenishmentErrorCodes["INVALID_INPUT"] = "INVALID_INPUT";
    ReplenishmentErrorCodes["NOT_FOUND"] = "NOT_FOUND";
    ReplenishmentErrorCodes["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    ReplenishmentErrorCodes["UNKNOWN_WHOLESALE_EVENT"] = "UNKNOWN_WHOLESALE_EVENT";
    ReplenishmentErrorCodes["DATABASE_ERROR"] = "DATABASE_ERROR";
    ReplenishmentErrorCodes["INBOUND_SERVICE_ERROR"] = "INBOUND_SERVICE_ERROR";
    ReplenishmentErrorCodes["CROSSDOCK_SERVICE_ERROR"] = "CROSSDOCK_SERVICE_ERROR";
    ReplenishmentErrorCodes["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    ReplenishmentErrorCodes["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
    ReplenishmentErrorCodes["TRANSPORTATION_SERVICE_ERROR"] = "TRANSPORTATION_SERVICE_ERROR";
    ReplenishmentErrorCodes["WAREHOUSE_SERVICE_ERROR"] = "WAREHOUSE_SERVICE_ERROR";
    ReplenishmentErrorCodes["WHOLESALE_SERVICE_ERROR"] = "WHOLESALE_SERVICE_ERROR";
    ReplenishmentErrorCodes["EVENT_PROCESSOR_NOT_ENABLED"] = "EVENT_PROCESSOR_NOT_ENABLED";
    ReplenishmentErrorCodes["UNSUPPORTED_CRON_ERROR"] = "UNSUPPORTED_CRON_ERROR";
    ReplenishmentErrorCodes["INVALID_STATE_TRANSITION"] = "INVALID_STATE_TRANSITION";
    ReplenishmentErrorCodes["STORAGE_SERVICE_ERROR"] = "STORAGE_SERVICE_ERROR";
    ReplenishmentErrorCodes["SELLER_SERVICE_ERROR"] = "SELLER_SERVICE_ERROR";
    ReplenishmentErrorCodes["FORBIDDEN_ERROR"] = "FORBIDDEN_ERROR";
    ReplenishmentErrorCodes["ALREADY_EXISTS"] = "ALREADY_EXISTS";
    ReplenishmentErrorCodes["ALREADY_CONFIRMED"] = "ALREADY_CONFIRMED";
    ReplenishmentErrorCodes["PROMISES_FAILED_ERROR"] = "PROMISES_FAILED_ERROR";
    ReplenishmentErrorCodes["INVENTORY_CLIENT_ERROR"] = "INVENTORY_CLIENT_ERROR";
    ReplenishmentErrorCodes["RSIP_SERVICE_ERROR"] = "RSIP_SERVICE_ERROR";
    ReplenishmentErrorCodes["ORDER_SUBMISSION_ERROR"] = "ORDER_SUBMISSION_ERROR";
    ReplenishmentErrorCodes["ORDER_CREATION_ERROR"] = "ORDER_CREATION_ERROR";
    ReplenishmentErrorCodes["ORDER_UPDATION_ERROR"] = "ORDER_UPDATION_ERROR";
    ReplenishmentErrorCodes["SAVE_ORDER_ERROR"] = "SAVE_ORDER_ERROR";
    ReplenishmentErrorCodes["PREP_SERVICE_ERROR"] = "PREP_SERVICE_ERROR";
    ReplenishmentErrorCodes["NON_COMPLIANCE_CANCELLATION_ERROR"] = "NON_COMPLIANCE_CANCELLATION_ERROR";
    ReplenishmentErrorCodes["UNKNOWN_WHOLESALE_INTEGRATIONS_EVENT"] = "UNKNOWN_WHOLESALE_INTEGRATIONS_EVENT";
    ReplenishmentErrorCodes["SQS_ERROR"] = "SQS_ERROR";
    ReplenishmentErrorCodes["FAILED_TO_PROCESS"] = "FAILED_TO_PROCESS";
    ReplenishmentErrorCodes["PRODUCT_CLIENT_ERROR"] = "PRODUCT_CLIENT_ERROR";
    ReplenishmentErrorCodes["EASY_POST_CLIENT_ERROR"] = "EASY_POST_CLIENT_ERROR";
    // Not found errors, must end with NOT_FOUND
    // 404s
    ReplenishmentErrorCodes["ORDER_NOT_FOUND"] = "ORDER_NOT_FOUND";
    ReplenishmentErrorCodes["CASE_PACK_NOT_FOUND"] = "CASE_PACK_NOT_FOUND";
    ReplenishmentErrorCodes["WAREHOUSE_NOT_FOUND"] = "WAREHOUSE_NOT_FOUND";
    ReplenishmentErrorCodes["ATTACHMENT_NOT_FOUND"] = "ATTACHMENT_NOT_FOUND";
    ReplenishmentErrorCodes["PRODUCT_NOT_FOUND"] = "PRODUCT_NOT_FOUND";
    ReplenishmentErrorCodes["SHIPMENT_NOT_FOUND"] = "SHIPMENT_NOT_FOUND";
    ReplenishmentErrorCodes["SHIPMENT_TRACKINGS_NOT_FOUND"] = "SHIPMENT_TRACKINGS_NOT_FOUND";
    ReplenishmentErrorCodes["WHOLESALE_SHIPMENT_NOT_FOUND"] = "WHOLESALE_SHIPMENT_NOT_FOUND";
    ReplenishmentErrorCodes["WHOLESALE_SHIPMENT_PACKAGES_NOT_FOUND"] = "WHOLESALE_SHIPMENT_PACKAGES_NOT_FOUND";
    ReplenishmentErrorCodes["PRO_NUMBER_OR_BOL_ID_NOT_FOUND"] = "PRO_NUMBER_OR_BOL_ID_NOT_FOUND";
    ReplenishmentErrorCodes["WHOLESALE_FREIGHT_METADATA_ITEMS_NOT_FOUND"] = "WHOLESALE_FREIGHT_METADATA_ITEMS_NOT_FOUND";
    ReplenishmentErrorCodes["PRODUCT_ALIAS_MAPPING_NOT_FOUND"] = "PRODUCT_ALIAS_MAPPING_NOT_FOUND";
    ReplenishmentErrorCodes["NON_COMPLIANCE_NOT_FOUND"] = "NON_COMPLIANCE_NOT_FOUND";
    // Auth Errors: 401s
    ReplenishmentErrorCodes["AUTH_ERROR"] = "AUTH_ERROR";
    ReplenishmentErrorCodes["MISSING_SELLER_CLIENT_SECRET"] = "MISSING_SELLER_CLIENT_SECRET";
    ReplenishmentErrorCodes["INVALID_SELLER_OAUTH_CREDENTIALS"] = "INVALID_SELLER_OAUTH_CREDENTIALS";
    // Validation Errors: 400s
    ReplenishmentErrorCodes["INVALID_PRODUCT"] = "INVALID_PRODUCT";
    ReplenishmentErrorCodes["CASE_QTY_MISMATCH"] = "CASE_QTY_MISMATCH";
    ReplenishmentErrorCodes["TOTAL_UNITS_NOT_DIVISIBLE_BY_CASE_QTY"] = "TOTAL_UNITS_NOT_DIVISIBLE_BY_CASE_QTY";
    ReplenishmentErrorCodes["INVALID_DISTRIBUTION_CHANNEL"] = "INVALID_DISTRIBUTION_CHANNEL";
    ReplenishmentErrorCodes["INVALID_EXTERNAL_DESTINATION_TYPE"] = "INVALID_EXTERNAL_DESTINATION_TYPE";
    ReplenishmentErrorCodes["MISSING_GTIN_UPC_EAN"] = "MISSING_GTIN_UPC_EAN";
    ReplenishmentErrorCodes["INVALID_ORDER_STATUS"] = "INVALID_ORDER_STATUS";
    ReplenishmentErrorCodes["INVALID_ORDER_ITEMS"] = "INVALID_ORDER_ITEMS";
    ReplenishmentErrorCodes["OUT_OF_STOCK"] = "OUT_OF_STOCK";
    ReplenishmentErrorCodes["UNRESOLVED_INVALID_ORDER_ITEMS"] = "UNRESOLVED_INVALID_ORDER_ITEMS";
    ReplenishmentErrorCodes["OVERLAPPING_DSKUS"] = "OVERLAPPING_DSKUS";
    ReplenishmentErrorCodes["MISSING_ORDER_ITEMS"] = "MISSING_ORDER_ITEMS";
    ReplenishmentErrorCodes["INVALID_SHIPMENT_STATUS"] = "INVALID_SHIPMENT_STATUS";
    ReplenishmentErrorCodes["SHIPMENT_STATUS_UPDATE_FAILED"] = "SHIPMENT_STATUS_UPDATE_FAILED";
    ReplenishmentErrorCodes["SAME_SKU_DIFFERENT_CASE_QTY_IN_SAME_ORDER"] = "SAME_SKU_DIFFERENT_CASE_QTY_IN_SAME_ORDER";
    ReplenishmentErrorCodes["INSUFFICIENT_INVENTORY"] = "INSUFFICIENT_INVENTORY";
    ReplenishmentErrorCodes["INCORRECT_STATE"] = "INCORRECT_STATE";
    ReplenishmentErrorCodes["FILE_MISSING"] = "FILE_MISSING";
    ReplenishmentErrorCodes["FILE_NO_CONTENT"] = "FILE_NO_CONTENT";
    ReplenishmentErrorCodes["FILE_TOO_BIG"] = "FILE_TOO_BIG";
    ReplenishmentErrorCodes["FILE_BAD_EXTENSION"] = "FILE_BAD_EXTENSION";
    ReplenishmentErrorCodes["MAX_DSKUS_LIMIT_REACHED"] = "MAX_DSKUS_LIMIT_REACHED";
    ReplenishmentErrorCodes["ASIN_MISSING"] = "ASIN_MISSING";
    ReplenishmentErrorCodes["LABEL_MISSING"] = "LABEL_MISSING";
    ReplenishmentErrorCodes["NOT_ENOUGH_INVENTORY_IN_SINGLE_WAREHOUSE"] = "NOT_ENOUGH_INVENTORY_IN_SINGLE_WAREHOUSE";
    ReplenishmentErrorCodes["DUPLICATE_ITEMS_IN_ORDER"] = "DUPLICATE_ITEMS_IN_ORDER";
    ReplenishmentErrorCodes["MSKU_NOT_FOUND"] = "MSKU_NOT_FOUND";
    ReplenishmentErrorCodes["MISSING_DSKU_FOR_MSKU"] = "MISSING_DSKU_FOR_MSKU";
    ReplenishmentErrorCodes["MISSING_CASE_PACK_FOR_DSKU"] = "MISSING_CASE_PACK_FOR_DSKU";
    ReplenishmentErrorCodes["DUPLICATE_EXTERNAL_ID"] = "DUPLICATE_EXTERNAL_ID";
    ReplenishmentErrorCodes["INVALID_PREP_OPTION"] = "INVALID_PREP_OPTION";
    ReplenishmentErrorCodes["HANDLED_AMAZON_ERROR"] = "HANDLED_AMAZON_ERROR";
    ReplenishmentErrorCodes["INVALID_CARRIER"] = "INVALID_CARRIER";
    ReplenishmentErrorCodes["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    ReplenishmentErrorCodes["INVALID_SHIPMENT_REQUEST"] = "INVALID_SHIPMENT_REQUEST";
    ReplenishmentErrorCodes["MISSING_LINE_ITEM_IDENTIFIER"] = "MISSING_LINE_ITEM_IDENTIFIER";
    ReplenishmentErrorCodes["UNAUTHORIZED_PRODUCT"] = "UNAUTHORIZED_PRODUCT";
    ReplenishmentErrorCodes["INVALID_TRANSPORTATION_DETAILS"] = "INVALID_TRANSPORTATION_DETAILS";
    ReplenishmentErrorCodes["INVALID_ADDRESS"] = "INVALID_ADDRESS";
    ReplenishmentErrorCodes["INVALID_POSTAL_CODE"] = "INVALID_POSTAL_CODE";
    ReplenishmentErrorCodes["SHEET_NOT_FOUND"] = "SHEET_NOT_FOUND";
    ReplenishmentErrorCodes["EMPTY_SHEET"] = "EMPTY_SHEET";
    ReplenishmentErrorCodes["MISSING_DSKU_OR_MSKU"] = "MISSING_DSKU_OR_MSKU";
    ReplenishmentErrorCodes["TOTAL_UNITS_NOT_EQUAL_TO_BOXES"] = "TOTAL_UNITS_NOT_EQUAL_TO_BOXES";
    ReplenishmentErrorCodes["INVALID_SHIPMENT_STATUS_FOR_ATTACHMENT"] = "INVALID_SHIPMENT_STATUS_FOR_ATTACHMENT";
    ReplenishmentErrorCodes["INVALID_PHONE_NUMBER"] = "INVALID_PHONE_NUMBER";
    // Estimation error
    ReplenishmentErrorCodes["INVALID_DIMS"] = "INVALID_DIMS";
    ReplenishmentErrorCodes["MISSING_DIMS"] = "MISSING_DIMS";
    ReplenishmentErrorCodes["INVALID_PALLET_QTY"] = "INVALID_PALLET_QTY";
    ReplenishmentErrorCodes["QUOTE_NOT_GENERATED"] = "QUOTE_NOT_GENERATED";
    ReplenishmentErrorCodes["EMPTY_QUOTE_RECEIVED"] = "EMPTY_QUOTE_RECEIVED";
    ReplenishmentErrorCodes["INVALID_SHIPPING_PARTNER"] = "INVALID_SHIPPING_PARTNER";
    ReplenishmentErrorCodes["AMAZON_SP_API_ERROR"] = "AMAZON_SP_API_ERROR";
    ReplenishmentErrorCodes["CARRIER_NOT_SUPPORTED"] = "CARRIER_NOT_SUPPORTED";
    ReplenishmentErrorCodes["MISSING_CARRIER_DETAILS"] = "MISSING_CARRIER_DETAILS";
    ReplenishmentErrorCodes["SHIPPING_METHOD_NOT_SUPPORTED"] = "SHIPPING_METHOD_NOT_SUPPORTED";
    ReplenishmentErrorCodes["MISSING_TRANSPORT_ESTIMATION"] = "MISSING_TRANSPORT_ESTIMATION";
    ReplenishmentErrorCodes["UNSUPPORTED_SOURCE"] = "UNSUPPORTED_SOURCE";
    ReplenishmentErrorCodes["SHIPPING_ESTIMATE_EXPIRED"] = "SHIPPING_ESTIMATE_EXPIRED";
    ReplenishmentErrorCodes["PALLET_COUNT_EXCEEDED"] = "PALLET_COUNT_EXCEEDED";
    // Shipment Attachment error
    ReplenishmentErrorCodes["ATTACHMENT_ALREADY_EXISTS"] = "ATTACHMENT_ALREADY_EXISTS";
    ReplenishmentErrorCodes["ATTACHMENT_NOT_EXISTS"] = "ATTACHMENT_NOT_EXISTS";
    ReplenishmentErrorCodes["ATTACHMENT_COPY_FAILED"] = "ATTACHMENT_COPY_FAILED";
    ReplenishmentErrorCodes["ATTACHMENT_UPLOAD_URL_INVALID_EXPIRY"] = "ATTACHMENT_UPLOAD_URL_INVALID_EXPIRY";
    // Shipment Tracking error
    ReplenishmentErrorCodes["FAILED_TO_SAVE_SHIPMENT_TRACKING"] = "FAILED_TO_SAVE_SHIPMENT_TRACKING";
    ReplenishmentErrorCodes["TRACKING_NOTIFICATION_NOT_NEEDED_FOR_NON_DELIVERR_SHIPPING_PARTNER"] = "TRACKING_NOTIFICATION_NOT_NEEDED_FOR_NON_DELIVERR_SHIPPING_PARTNER";
    ReplenishmentErrorCodes["TRACKING_NOTIFICATION_NOT_NEEDED_FOR_ECOM"] = "TRACKING_NOTIFICATION_NOT_NEEDED_FOR_ECOM";
    ReplenishmentErrorCodes["SHIPMENT_TRACKING_ALREADY_EXISTS"] = "SHIPMENT_TRACKING_ALREADY_EXISTS";
    //Shipment plan errors
    ReplenishmentErrorCodes["INVALID_SHIPMENT_PLAN"] = "INVALID_SHIPMENT_PLAN";
    ReplenishmentErrorCodes["MISSING_RESPONSE"] = "MISSING_RESPONSE";
    ReplenishmentErrorCodes["MISSING_SHIPMENT_PLANS"] = "MISSING_SHIPMENT_PLANS";
    ReplenishmentErrorCodes["ORDER_CANCELLATION_FAILED"] = "ORDER_CANCELLATION_FAILED";
    ReplenishmentErrorCodes["SAVE_SHIPMENT_FAILED"] = "SAVE_SHIPMENT_FAILED";
    // Walmart Errors
    ReplenishmentErrorCodes["WALMART_WFS_API_ERROR"] = "WALMART_WFS_API_ERROR";
    ReplenishmentErrorCodes["WALMART_ORDER_CANCELLATION_FAILED"] = "WALMART_ORDER_CANCELLATION_FAILED";
    ReplenishmentErrorCodes["SELLER_NOT_ENABLED_FOR_WFS"] = "SELLER_NOT_ENABLED_FOR_WFS";
    ReplenishmentErrorCodes["ITEM_NOT_ELIGIBLE_FOR_WFS"] = "ITEM_NOT_ELIGIBLE_FOR_WFS";
    ReplenishmentErrorCodes["WFS_ORDER_ALREADY_CANCELLED"] = "WFS_ORDER_ALREADY_CANCELLED";
    ReplenishmentErrorCodes["WFS_RATE_LIMITING"] = "WFS_RATE_LIMITING";
    // Channel Errors
    ReplenishmentErrorCodes["CHANNEL_ORDER_ACKNOWLEDGEMENT_FAILED"] = "CHANNEL_ORDER_ACKNOWLEDGEMENT_FAILED";
    ReplenishmentErrorCodes["CHANNEL_SHIPMENT_FETCH_FAILED"] = "CHANNEL_SHIPMENT_FETCH_FAILED";
    ReplenishmentErrorCodes["CHANNEL_ORDER_CREATION_FAILED"] = "CHANNEL_ORDER_CREATION_FAILED";
    // Submission error
    ReplenishmentErrorCodes["WHOLESALE_ORDER_SUBMISSION_FAILED"] = "WHOLESALE_ORDER_SUBMISSION_FAILED";
    ReplenishmentErrorCodes["CHANNEL_ORDER_SUBMISSION_FAILED"] = "CHANNEL_ORDER_SUBMISSION_FAILED";
    // Amazon Errors
    ReplenishmentErrorCodes["FEED_CARTON_FAILED"] = "FEED_CARTON_FAILED";
    ReplenishmentErrorCodes["NOT_VALID_FOR_AMAZON_TRANSPORT"] = "NOT_VALID_FOR_AMAZON_TRANSPORT";
    ReplenishmentErrorCodes["PATCH_REFERENCE_NUMBER_FAILED"] = "PATCH_REFERENCE_NUMBER_FAILED";
    // SNS Errors
    ReplenishmentErrorCodes["SNS_BATCH_PUBLISH_FAILED"] = "SNS_BATCH_PUBLISH_FAILED";
    // Step Function
    ReplenishmentErrorCodes["STEP_FUNCTION_ASYNC_TRIGGER_FAILED"] = "STEP_FUNCTION_ASYNC_TRIGGER_FAILED";
    ReplenishmentErrorCodes["AMAZON_SHIPMENT_STATUS_NOT_MAPPED"] = "AMAZON_SHIPMENT_STATUS_NOT_MAPPED";
    ReplenishmentErrorCodes["WALMART_SHIPMENT_STATUS_NOT_MAPPED"] = "WALMART_SHIPMENT_STATUS_NOT_MAPPED";
    // Operation Errors
    ReplenishmentErrorCodes["OPERATION_NOT_FOUND"] = "OPERATION_NOT_FOUND";
    ReplenishmentErrorCodes["OPERATION_ERROR"] = "OPERATION_ERROR";
    ReplenishmentErrorCodes["PACKING_OPTIONS_NOT_GENERATED"] = "PACKING_OPTIONS_NOT_GENERATED";
    ReplenishmentErrorCodes["MULTIPLE_PACKING_OPTIONS_CONFIRMED"] = "MULTIPLE_PACKING_OPTIONS_CONFIRMED";
    ReplenishmentErrorCodes["ITEMS_MISMATCH"] = "ITEMS_MISMATCH";
    ReplenishmentErrorCodes["ITEMS_QUANTITY_MISMATCH"] = "ITEMS_COUNT_MISMATCH";
    ReplenishmentErrorCodes["ITEMS_UNITS_MISMATCH"] = "ITEMS_UNITS_MISMATCH";
    ReplenishmentErrorCodes["PLACEMENT_OPTIONS_NOT_GENERATED"] = "PLACEMENT_OPTIONS_NOT_GENERATED";
    ReplenishmentErrorCodes["MULTIPLE_PLACEMENT_OPTIONS_CONFIRMED"] = "MULTIPLE_PLACEMENT_OPTIONS_CONFIRMED";
    ReplenishmentErrorCodes["INVALID_SHIPPING_PREFERENCES"] = "INVALID_SHIPPING_PREFERENCES";
    ReplenishmentErrorCodes["DUPLICATE_OPERATIONS_FOUND"] = "DUPLICATE_OPERATIONS_FOUND";
    // Unprocessable Entity
    ReplenishmentErrorCodes["NO_AVAILABLE_WAREHOUSES"] = "NO_AVAILABLE_WAREHOUSES";
})(ReplenishmentErrorCodes || (exports.ReplenishmentErrorCodes = ReplenishmentErrorCodes = {}));
//# sourceMappingURL=ReplenishmentErrorCodes.js.map